module.exports = __webpack_public_path__ + "img/icon.31abff12.png";